import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Navigation, Router } from '@angular/router';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { TransferStoreFacade } from '../../../common/facade/TransferStoreFacade';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { TransferStoreEntry } from '../../../common/model/TransferStoreEntry';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-transfer-store-entry',
    templateUrl: './transfer-store-entry.component.html',
    styleUrls: ['./transfer-store-entry.component.css']
})
export class TransferStoreEntryComponent implements OnInit {
    titleTransfer = res.Transfer;
    titleInvoicesEntry = res.FoliosTransferEntryTitle
  lblDetailIngress = res.Detail;
  lblDownload = res.Download;
  lblSelectAnOption = res.SelectAnOption;
    lblSearch = res.Search;
    lblOrigin = res.Origin;
    lblDestination = res.Destination;

  lblInvoice = res.TransferStoreEntry;
  lblEmployeeRecived = res.EmployeeRecibedEntry;
  lblEmployeeConfirmedEntry = res.EmployeeConfirmedEntry;
  lblReceivedDate = res.ReceivedDate;
  lblArticlesEntered = res.ArticlesEntered;
  lblDetail = res.Detail;
  lblView = res.View;
  
  isSpanish = true;
  language = 0;

  messagesTable : any = {
    emptyMessage: "",
    totalMessage: "" 
  }

  loading = false;
  messageLoader = '';
  // alert
  alerts = [];
  // info Header
  storeOriginName = '';
  storeDestinyName = '';
  // Filtros
  gender = '-1';
  genders = [];
  style = '-1';
  styles = [];

    rows: TransferStoreEntry[] = [];
    private _filteredData: TransferStoreEntry[] = [];

  transferReqId = '';


    constructor(
        private _router: Router,
        private _excel: ExcelUtility,
        private _transferStoreFacade: TransferStoreFacade,
        private _activatedRoute: ActivatedRoute,
        private _datePipe: DatePipe,
        public strings: Strings
    ) {
        let nav: Navigation = this._router.getCurrentNavigation();

        if (nav.extras && nav.extras.state) {
            this.storeOriginName = nav.extras.state.origin;
            this.storeDestinyName = nav.extras.state.destiny;
        }  
        
    }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    if (!this.isSpanish) {
      this.language = 1
      }

    this.getTransferEntry();
  }

  private getTransferEntry() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    const id = this._activatedRoute.snapshot.paramMap.get('id');
    this.transferReqId = id;
      this._transferStoreFacade.GetTransferStoreEntry(id).subscribe(
      response => {
        this.loading = false;
        this.rows = response.data;
        this._filteredData = response.data;
        this.gender = '-1';
        this.style = '-1';        
        
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheTransfersCouldNotBeObtained), 'danger');
      }
    );
    }

    // Filtros
     updateFilter(event) {
        // get the value of the key pressed and make it lowercase
        const val = event.target.value.toLowerCase();
        // get the key names of each column in the dataset
        const keys = Object.keys(this._filteredData[0]);
        // assign filtered matches to the active datatable
        this.rows = this._filteredData.filter(function (item) {
            // iterate through each row's column data
            for (let i = 0; i < keys.length; i++) {
                if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                    return true;
                }
            }
        });
    }       

  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent) {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

  // Save excel
  downloadLayout() {
     if (this.rows.length > 0) {
       const data: any = [];
         this.rows.forEach(row => {
             let info: any
             if (this.isSpanish) {
                 info = {
                     [this.strings.GetText(res.TransferStoreEntry)]: row.transferEntryStoreId,
                     [this.strings.GetText(res.EmployeeRecibedEntry)]: row.employeeIdReceived,
                     [this.strings.GetText(res.EmployeeConfirmedEntry)]: row.employeeIdReceivedConfirm,
                     [this.strings.GetText(res.ReceivedDate)]: this._datePipe.transform(row.receivedDate, 'dd/MM/yyyy'), 
                     [this.strings.GetText(res.ArticlesEntered)]: row.quantityItemIngress
                 };
             }
             else {
                 info = {
                     [this.strings.GetText(res.TransferStoreEntry)]: row.transferEntryStoreId,
                     [this.strings.GetText(res.EmployeeRecibedEntry)]: row.employeeIdReceived,
                     [this.strings.GetText(res.EmployeeConfirmedEntry)]: row.employeeIdReceivedConfirm,
                     [this.strings.GetText(res.ReceivedDate)]: this._datePipe.transform(row.receivedDate, 'MM/dd/yyyy'),
                     [this.strings.GetText(res.ArticlesEntered)]: row.quantityItemIngress
                 };
             }
           
         data.push(info);
       });
         this._excel.exportAsExcelFile(data, this.strings.GetText(res.Transfer) + ' - ' + this.transferReqId);
     } else {
       this.addAlert(this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile), 'danger');
     }
  }

    onViewDetail(id) {
      this._router.navigate(['transfer/store/entry/detail/', id],
          { state: { origin: this.storeOriginName, destiny: this.storeDestinyName, idTranfer: this.transferReqId } }
                  );
  }

}
